import {lazy} from "react";
import {authRoles} from "app/auth/authRoles";

const DocumentLoteRoot = lazy(() => import("./document-lote-root"));

const documentLoteRoutes = [
    {
        path: "/document-lote",
        element: <DocumentLoteRoot/>,
        auth: authRoles.admin,
    },
];

export default documentLoteRoutes;